import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

import useHostHubData from "../hooks/useHostHubData";

const HostHubOverviewHeader = () => {
  const { hasAnyTodo } = useHostHubData();

  const topPriorityLabel = hasAnyTodo ? (
    <Text className="tw-my-0" typeface="body-1-m">
      <FormattedMessage
        defaultMessage="Top priority"
        id="host_hub.todo_list.top_priority"
      />
    </Text>
  ) : null;

  return (
    <>
      <Text className="tw-my-0" element="h2" typeface="headline-3-m">
        <FormattedMessage
          defaultMessage="To do list"
          id="host_hub.todo_list.title"
        />
      </Text>
      {topPriorityLabel}
    </>
  );
};

export default HostHubOverviewHeader;
